export default __webpack_public_path__ + "static/image-5-ec78b9eaf1ea458388c9804110710cc6.jpg";